let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("4Oj5y"), load("3b99S"), load("9wTW2")]).then(() => parcelRequire('dFOTO'));